import designPC from '@/assets/images/designPc.png';
import { Image } from '@/components/Image';
import { Logo } from '@/components/Logo';
import { Text } from '@/components/Text';
import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  welcomeText?: string;
  showIllustration?: boolean;
}

export const AuthLayout = ({
  children,
  title,
  welcomeText = '',
  showIllustration = true,
}: AuthLayoutProps) => {
  return (
    <div className="flex min-h-screen w-full items-stretch bg-gradient-to-br from-sky-900 via-sky-700 to-sky-500 p-2 md:p-4">
      {/* Conteneur principal */}
      <div className="m-auto flex w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white md:flex-row">
        {/* Partie gauche - Illustration et message de bienvenue */}
        {showIllustration && (
          <div className="hidden md:flex md:w-1/2 md:flex-col md:items-center md:justify-center md:bg-gradient-to-br md:from-sky-50 md:to-sky-100 md:p-6">
            <div className="flex flex-col items-center justify-center text-center">
              <Text className="mb-4 bg-gradient-to-r from-linko-dark to-linko-light bg-clip-text text-3xl font-bold text-transparent">
                {title}
              </Text>
              <div className="relative mb-6 w-full max-w-md">
                <Image
                  src={designPC}
                  alt="Design PC"
                  className="relative z-10 w-full rounded-lg"
                />
              </div>
              {welcomeText && (
                <Text className="max-w-md bg-gradient-to-r from-linko-dark to-linko-light bg-clip-text text-lg font-medium text-transparent">
                  {welcomeText}
                </Text>
              )}
            </div>
          </div>
        )}

        {/* Partie droite - Contenu */}
        <div
          className={`flex w-full flex-col items-center justify-center p-4 ${
            showIllustration ? 'md:w-1/2' : ''
          } md:p-6`}
        >
          <Logo className="mb-4 w-36 md:mb-5 md:w-44" variant={'full'} />
          <div className="flex w-full flex-col items-center">{children}</div>
        </div>
      </div>
    </div>
  );
};
